import { HttpService } from "@/core";
import {
  CompanyContactReq,
  CompanyContactListResp,
  CompanyContactDetailResp,
  Company,
  FileResp,
} from "./company-contact.interface";

export class CompanyContactService {
  static useListApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cooperation_company/${id}/contacts`,
      });
    return HttpService.useRequest<CompanyContactListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cooperation_company_contacts/${id}`,
      });
    return HttpService.useRequest<CompanyContactDetailResp>(api);
  }

  static useCreateApi() {
    const api = (id: string, data: CompanyContactReq) =>
      HttpService.axios({
        method: "POST",
        url: `/cooperation_company/${id}/contacts`,
        data: {
          records: [data],
        },
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: CompanyContactReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/cooperation_company_contacts/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditContactsListApi() {
    const api = (id: string, data: CompanyContactReq) =>
      HttpService.axios({
        method: "POST",
        url: `/cooperation_company/${id}/addContactsList`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (ids: string[]) =>
      HttpService.axios({
        method: "DELETE",
        url: "/cooperation_company_contacts",
        params: { ids: ids.join(",") },
      });
    return HttpService.useRequest<void>(api);
  }

}
